// @flow

import React from 'react';
import styles from './basicSelect.scss';

import { getUniqueId } from '../../../../services/helpers';

const dropdownIcnUrl = require('../../../../assets/images/dropdown_icn.svg');

type Props = {
  optionsArrOfObj: Array<any>,
  label: string,
  onSelect: Function,
  nameValStrings?: Object,
  selectedOpt?: string,
  enableSearch?: boolean,
  onChangeInput?: Function,
  showOptions?: boolean,
  disabled?: boolean,
  displayNone?: boolean
};

type State = {
  selectedOpt: string,
  showOptions: boolean,
  optionsArrOriginal: Array<any>,
  optionsArrFiltered: Array<any>
};
class BasicSelect extends React.Component<Props, State> {
  constructor(props: Object) {
    super(props);
    this.state = {
      selectedOpt: this.props.selectedOpt || '',
      showOptions: this.props.showOptions || false,
      optionsArrOriginal: this.props.optionsArrOfObj,
      optionsArrFiltered: this.props.optionsArrOfObj
    };
    this.nameKey =
      (this.props.nameValStrings && this.props.nameValStrings.nameKey) || 'key';
    this.valKey =
      (this.props.nameValStrings && this.props.nameValStrings.valKey) || 'val';

    this.selectLabelId = `select-label-${getUniqueId(4)}`;
    this.inputFieldId = `input-field-${getUniqueId(4)}`;
  }

  componentDidMount() {
    this.attachDocumentLevelEventHandler(); // hacky solution
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedOpt !== this.props.selectedOpt) {
      this.setState({
        selectedOpt: nextProps.selectedOpt
      });
    }
    if (
      nextProps.showOptions &&
      nextProps.showOptions !== this.props.showOptions
    ) {
      this.setState({
        showOptions: nextProps.showOptions
      });
    }
    if (nextProps.optionsArrOfObj) {
      this.setState({
        optionsArrOriginal: nextProps.optionsArrOfObj,
        optionsArrFiltered: nextProps.optionsArrOfObj
      });
    }
  }

  handleChange(val: string) {
    if (this.props.onChangeInput) {
      this.props.onChangeInput(val);
      this.setState({
        inputVal: val
      });
    } else {
      this.setState(
        {
          inputVal: val
        },
        () => this.filterOptionsArr() // update array of elements
      );
    }
  }

  filterOptionsArr() {
    const searchStr = this.state.inputVal && this.state.inputVal.toLowerCase();

    const filteredArr = this.state.optionsArrOriginal.filter(
      elem => elem[this.nameKey].toLowerCase().indexOf(searchStr) >= 0
    );

    this.setState({
      optionsArrFiltered: filteredArr
    });
  }

  selectOption(val: string, obj: Object) {
    this.setState(
      {
        selectedOpt: val
      },
      () => {
        if (this.props.onSelect) this.props.onSelect(val, obj);
      }
    );
  }

  attachDocumentLevelEventHandler() {
    // flow-disable-next-line
    document.querySelector('body').addEventListener('mousedown', e => {
      const elem = e.target.closest(`#${this.selectLabelId}`); // select-wrapper-id

      const inputSearchElem = e.target.closest(`#${this.inputFieldId}`); // search input

      // eslint-disable-next-line
      if ((elem && !this.state.showOptions) || inputSearchElem) {
        // show options-wrapper
        this.setState({
          showOptions: true
        });
      } else if (!elem && this.state.showOptions) {
        // on blur
        // this.handleBlur();
        // hide options wrapper
        setTimeout(() => {
          this.setState({
            showOptions: false
          });
        }, 200);
      }
    });
  }

  selectLabelId: string;
  nameKey: string;
  valKey: string;
  inputFieldId: string;

  renderOptions() {
    return this.state.optionsArrFiltered.map((elem, i) => (
      <div
        className={`${styles.optionRow} l-row a-center`}
        onClick={() => this.selectOption(elem[this.valKey], elem)}
        title={elem[this.nameKey]}
        key={i}
      >
        {elem[this.nameKey]}
      </div>
    ));
  }

  render() {
    return (
      <div id="select-wrapper-id" className={styles.selectWrapper}>
        <div
          id={this.selectLabelId}
          className={`${styles.labelWrapper} l-row a-center"`}
        >
          <div
            className={`${styles.selectLabel} l-row a-center select-label`}
            title={
              this.state.selectedOpt ? this.state.selectedOpt : this.props.label
            }
          >
            {this.state.selectedOpt ? this.state.selectedOpt : this.props.label}
          </div>
          <div className={`${styles.selectArrowIcn} l-row a-center`}>
            <img src={dropdownIcnUrl} alt="" />
          </div>
        </div>

        {this.state.showOptions ? (
          <div className={`${styles.optionsWrapper}`}>
            {this.props.enableSearch ? (
              <div
                className={`${styles.optionRow} ${styles.searchWrapper} l-row a-center`}
              >
                <input
                  id={this.inputFieldId}
                  className={`${styles.selectSearchInput}`}
                  placeholder="search"
                  value={this.state.inputVal || ''}
                  onChange={e => this.handleChange(e.target.value)}
                />
              </div>
            ) : null}

            {!this.props.disabled ? (
              <div className={`${styles.optionsRowParent} options-row-parent`}>
                {this.props.displayNone ? (
                  <div
                    className={`${styles.optionRow} l-row a-center`}
                    onClick={() => this.selectOption('')}
                  >
                    NONE
                  </div>
                ) : null}

                {this.renderOptions()}
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    );
  }
}

BasicSelect.defaultProps = {
  optionsArrOfObj: [],
  label: 'Select Option',
  nameValStrings: {},
  selectedOpt: '',
  enableSearch: false,
  showOptions: false,
  disabled: false,
  displayNone: false
};

export default BasicSelect;
